import i18n from 'config/i18n';
import * as yup from 'yup';

import { getLocale } from 'utils/date';

import getPeriodSchema from './ControlledTimePeriodSchema';

const periodSchema = getPeriodSchema();

const getSchema = () => {
  const t = i18n.getFixedT(getLocale(), 'common');

  return yup
    .array()
    .of(periodSchema)
    .min(1, t('validation.atLeastOneIsRequired'))
    .required();
};

export default getSchema;
